import styled from '@emotion/styled'

export const TimesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: 1.25rem;

  > div:nth-of-type(0) {
    max-width: 10rem;
  }

  > div:nth-of-type(1) {
    width: 10rem;
  }
`
